<div class="row heading-container">
  <div class="column">
    <span>Find any Property, Customer or Receipt</span>
  </div>
</div>
<div class="column">
  <div class="search-bar">
    <mat-form-field appearance="outline">
      <mat-label>Select search type</mat-label>
      <mat-select [(ngModel)]="searchType">
        <mat-option [value]="SearchType.CUSTOMER">{{SearchType.CUSTOMER.toString()}}</mat-option>
        <mat-option [value]="SearchType.PROPERTY">{{SearchType.PROPERTY.toString()}}</mat-option>
        <mat-option [value]="SearchType.RECEIPT">{{SearchType.RECEIPT.toString()}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
@switch (searchType){
  @case (SearchType.CUSTOMER){
    <app-customer-search></app-customer-search>
  }
  @case (SearchType.PROPERTY){
    <app-property-search-list></app-property-search-list>
  }
  @case (SearchType.RECEIPT){
    <app-receipt-search></app-receipt-search>
  }
  @default {
    <p>Please select a search type.</p>
  }
}

